/*!
 * Copyright 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { AppConfigModule, AppConfigService, LoginModule } from '@alfresco/adf-core';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [LoginModule, AppConfigModule, TranslateModule],
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent {
  myCustomLogo: any;
  myCustomBg: any;

  myCustomLandingPage: any;

  constructor(private config: AppConfigService, public router: Router) {
    if (this.config.get<string>('application.logoLogin')) {
      this.myCustomLogo = this.config.get<string>('application.logoLogin');
    } else {
      this.myCustomLogo = './assets/images/login-logo.svg';
    }

    if (this.config.get<string>('application.bgLogin')) {
      this.myCustomBg = this.config.get<string>('application.bgLogin');
    } else {
      this.myCustomBg = './assets/images/Wallpaper-BG-generic.svg';
    }

    if (this.config.get<string>('application.LandingPage')) {
      this.myCustomLandingPage = this.config.get<string>('application.LandingPage');
    } else {
      this.myCustomLandingPage = '/personal-files';
    }
  }

  onMyAuthLogin($event) {
    // Get the configured landing page or use default
    const landingPage = this.config.get<string>('application.LandingPage') || this.myCustomLandingPage;
    console.log('Navigating to landing page:', landingPage);
    // First navigate to landing page
    this.router
      .navigate([landingPage])
      .then(() => {
        console.log('Navigation successful, current URL:', this.router.url);
        console.log('Auth token:', $event.token.ticket);
        // Only reload after successful navigation
        console.log('Reloading page to refresh authentication...');
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((error) => {
        console.error('Navigation failed:', error);
        // Fallback to direct reload if navigation fails
        window.location.reload();
      });
  }
}
